import { render, staticRenderFns } from "./BusinessPlanPayment.vue?vue&type=template&id=08086897"
import script from "./BusinessPlanPayment.vue?vue&type=script&lang=js"
export * from "./BusinessPlanPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports